export * from "./terms-template.dto.interface";
export * from "./terms-template-search.dto.interface";
